import { UserSettings } from '@/modules/core/app/models/UserSettings';
import { SessionVars } from '@/modules/core/session/session.constants';
import { OnboardingFlow } from '@/modules/core/onboarding/onboarding.constants';

export const mutations = {
  /**
   * @param {SessionState} state
   * @param {{}} userSettings
   */
  setUserSettings(state, userSettings) {
    state.userSettings = new UserSettings(userSettings);
  },
  /**
   * Targeted: spreading UserSettings through setUserSettings drops snake_case-sourced fields.
   *
   * @param {SessionState} state
   * @param {string} preferredOnboardingFlow
   */
  setPreferredOnboardingFlow(state, preferredOnboardingFlow) {
    state.userSettings.preferredOnboardingFlow = preferredOnboardingFlow;
    // Keep the derived decision coherent, so an optimistic switch applies immediately.
    state.userSettings.isAutopilotOnboardingFlow =
      Boolean(state.userSettings.isFreeTrial) && preferredOnboardingFlow !== OnboardingFlow.CLASSIC;
  },
  /**
   * @param {SessionState} state
   * @param {boolean} value
   */
  isLoggingIn(state, value) {
    state.status.isLoggingIn = value;
  },
  /**
   * @param {SessionState} state
   * @param {boolean} value
   */
  isLoggingOut(state, value) {
    state.status.isLoggingOut = value;
  },
  /**
   * @param {SessionState} state
   */
  setLoggedOut(state) {
    state.userSettings.isLoggedIn = false;
  },
  /**
   * @param {SessionState} state
   * @param {boolean} value
   */
  setLoginRedirectPath(state, value) {
    try {
      const url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin) {
        return;
      }
    } catch {
      return;
    }
    state.loginRedirectPath = value;
    window.localStorage.setItem(SessionVars.LOGIN_REDIRECT_PATH, value);
  },
  /**
   * @param {SessionState} state
   */
  resetLoginRedirectPath(state) {
    state.loginRedirectPath = null;
    window.localStorage.removeItem(SessionVars.LOGIN_REDIRECT_PATH);
  },

  /**
   * @param {SessionState} state
   * @param {boolean} value
   */
  setShowWelcomeModal(state, value) {
    state.showWelcomeModal = value;
  },
  /**
   * @param {SessionState} state
   * @param {BrandMapping} mapping
   */
  setBrandMapping(state, mapping) {
    state.brandMapping = mapping;
  },

  /**
   *
   * @param state
   * @param value
   */
  setClientCurrency(state, value) {
    state.clientCurrency = value;
  },
};
